import { render, staticRenderFns } from "./ComGroup.vue?vue&type=template&id=77c15c2d&scoped=true&"
import script from "./ComGroup.vue?vue&type=script&lang=js&"
export * from "./ComGroup.vue?vue&type=script&lang=js&"
import style0 from "./ComGroup.vue?vue&type=style&index=0&id=77c15c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c15c2d",
  null
  
)

export default component.exports